import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gift-cards-banner-home',
  templateUrl: './gift-cards-banner-home.component.html',
  styleUrls: ['./gift-cards-banner-home.component.scss']
})
export class GiftCardsBannerHomeComponent implements OnInit {
  @Output() onReadMore = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

}
